import { ManufacturerService } from 'src/app/_service/manufacturer.service';
import { Component, OnInit, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { AlertifyService } from 'src/app/_service/alertify.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { AppCustomDirective } from 'src/app/_extensions/app.validators';

@Component({
  selector: 'create-manufacturer',
  templateUrl: './create-manufacturer.component.html',
  styleUrls: ['./create-manufacturer.component.css']
})
export class CreateManufacturerComponent implements OnInit {
@Output() setManufacturer = new EventEmitter<any>();

model: any = {};
selected: number;
selectedContactInfo: number;
isLoading = false;
locationArray: number;
selectedSearchParameter = '4';
duplicateManufacturerName: any = {};
createManufacturerForm: FormGroup;
limittotoday = new Date();
show = false;

effectiveContactMethodArray: any = [];
emailChecked: any;
formUrlChecked: any;
phoneChecked: any;
faxChecked: any;
DaterForm: FormGroup;

mostRecentContact: string;
mostRecentContactFC: any;

ContactLocationFormControl = new FormControl();
  ContactLocationGroups: ContactLocationGroup[] = [
    {
      name: 'Contact Location',
      contactLocation: [
        {value: '0', viewValue: 'Unknown'},
        {value: '1', viewValue: 'Canada'},
        {value: '2', viewValue: 'USA'},
        {value: '3', viewValue: 'Europe'},
        {value: '4', viewValue: 'Other'}
      ]
    }
  ];

  changeMostRecentContact(event) {
    this.mostRecentContact = event.target.value;
  }

  emailCheckBox($event) {
    console.log($event.checked);
    if ($event.checked) {
      this.effectiveContactMethodArray.push(1);
      console.log(this.effectiveContactMethodArray);
    } else {
      const objIndex = this.effectiveContactMethodArray.findIndex(obj => obj == 1);
      if (objIndex > -1) {
        this.effectiveContactMethodArray.splice(objIndex, 1);
      }
    }
  }

  formURLCheckBox($event) {
    console.log($event.checked);
    if ($event.checked) {
      console.log('form url checked');
      this.effectiveContactMethodArray.push(2);
      console.log(this.effectiveContactMethodArray);
      return this.formUrlChecked = 2;
    } else {
      const objIndex = this.effectiveContactMethodArray.findIndex(obj => obj == 2);
      if (objIndex > -1) {
        this.effectiveContactMethodArray.splice(objIndex, 1);
      }
      console.log(this.effectiveContactMethodArray);    
    }
  }


  phoneCheckBox($event) {
    console.log($event.checked);
    if ($event.checked) {
      console.log('phone checked');
      this.effectiveContactMethodArray.push(3);
      console.log(this.effectiveContactMethodArray);
      return this.phoneChecked = 3;
    } else {
      const objIndex = this.effectiveContactMethodArray.findIndex(obj => obj == 3);
      if (objIndex > -1) {
        this.effectiveContactMethodArray.splice(objIndex, 1);
      }
      console.log(this.effectiveContactMethodArray);    }
  }

  faxCheckBox($event) {
    console.log($event.checked);
    if ($event.checked) {
      console.log('fax checked');
      this.effectiveContactMethodArray.push(4);
      console.log(this.effectiveContactMethodArray);
      return this.faxChecked = 4;
    } else {
      const objIndex = this.effectiveContactMethodArray.findIndex(obj => obj == 4);
      if (objIndex > -1) {
        this.effectiveContactMethodArray.splice(objIndex, 1);
      }
      console.log(this.effectiveContactMethodArray);
      }
  }

   onSelectContactLocation(selectedContactInfo) {
    this.locationArray = selectedContactInfo[0];
    this.model.contactLocationId = this.locationArray;
    console.log(this.locationArray);
  }

  selectedContactLocation(event) {
    console.log(event);
    if (event.value === '0') {
      this.selectedSearchParameter = event.value;
    }
    if (event.value === '1') {
      this.selectedSearchParameter = event.value;
    }
    if (event.value === '2') {
      this.selectedSearchParameter = event.value;
    }
    if (event.value === '3') {
      this.selectedSearchParameter = event.value;
    }
    if (event.value === '4') {
      this.selectedSearchParameter = event.value;
    }
  }

  constructor(
    private manufacturerService: ManufacturerService,
    private alertify: AlertifyService,
    private router: Router,
    public fb: FormBuilder,
    public cdr: ChangeDetectorRef,
    public dialog: MatDialog) {
      this.DaterForm = this.fb.group(
        {
          FromDate: ['', [AppCustomDirective.fromDateValidator]]
        });

      this.createManufacturerForm = fb.group({
        manufacturerNameFormControl: new FormControl('', [
          Validators.required,
          this.WhitespaceValidator,
          Validators.maxLength(250)
        ]),
        urlFormControl: new FormControl('', [Validators.maxLength(500)]),
        sdsUrlFormControl: new FormControl('', [Validators.maxLength(500)]),
        alternativeNamesFormControl: new FormControl('', [Validators.maxLength(250)]),
        notesFormControl: new FormControl('', [Validators.maxLength(1000)]),
        contactLocationFormControl: new FormControl('', []).clearValidators(),
        mostRecentContactFormControl: new FormControl('', []).clearValidators(),
        // Effective contact method
        emailContactFormControl: new FormControl('', [Validators.maxLength(75)]),
        formUrlContactFormControl: new FormControl('', [Validators.maxLength(125)]),
        phoneContactFormControl: new FormControl('', [Validators.maxLength(20)]),
        faxContactFormControl: new FormControl('', [Validators.maxLength(20)]),
        contactDetailsFormControl: new FormControl('', [Validators.maxLength(500)]),
        // Effective contact method checkbox
        emailCheckBoxFormControl: new FormControl('', []).clearValidators(),
        formUrlCheckBoxFormControl: new FormControl('', []).clearValidators(),
        phoneCheckBoxFormControl: new FormControl('', []).clearValidators(),
        faxCheckBoxFormControl: new FormControl('', []).clearValidators(),
      });
      this.limittotoday.setDate(this.limittotoday.getDate());
     }

  ngOnInit() {
    this.mostRecentContactFC = this.createManufacturerForm.get('mostRecentContactFormControl');
    this.mostRecentContactFC.markAsTouched();
  }

  public WhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  ngAfterViewChecked() {
    const show = this.validateFormControl(this.createManufacturerForm);
    if (show != this.show) {
      this.show = show;
      this.cdr.detectChanges();
    }
    this.cdr.detectChanges();
  }

  public validateFormControl(control) {
    if (control.status === 'VALID') {
      return true;
    } else {
      return false;
    }
  }

  private validateEffectiveContactMethods() {
    // Email checkbox validation
    if (this.effectiveContactMethodArray.includes(1) && this.model.contactEmail === '') {
      const index = this.effectiveContactMethodArray.indexOf(1);
      this.effectiveContactMethodArray.splice(index, 1);
      this.emailChecked = false;
      this.createManufacturerForm.get('emailCheckBoxFormControl').setValue(false);
    }
    
    // Form URL checkbox validation
    if (this.effectiveContactMethodArray.includes(2) && this.model.contactUrl === '') {
      const index = this.effectiveContactMethodArray.indexOf(2);
      this.effectiveContactMethodArray.splice(index, 1);
      this.formUrlChecked = false;
      this.createManufacturerForm.get('formUrlCheckBoxFormControl').setValue(false);
    }
    
    // Phone checkbox validation
    if (this.effectiveContactMethodArray.includes(3) && this.model.contactPhoneNumber === '') {
      const index = this.effectiveContactMethodArray.indexOf(3);
      this.effectiveContactMethodArray.splice(index, 1);
      this.phoneChecked = false;
      this.createManufacturerForm.get('phoneCheckBoxFormControl').setValue(false);
    }
    
    // Fax checkbox validation
    if (this.effectiveContactMethodArray.includes(4) && this.model.contactFaxNumber === '') {
      const index = this.effectiveContactMethodArray.indexOf(4);
      this.effectiveContactMethodArray.splice(index, 1);
      this.faxChecked = false;
      this.createManufacturerForm.get('faxCheckBoxFormControl').setValue(false);
    }
  }

createManufacturers() {
  this.model.manufacturerName = this.createManufacturerForm.get('manufacturerNameFormControl').value.trim();
  this.model.url = this.createManufacturerForm.get('urlFormControl').value === null ? '' : 
  this.createManufacturerForm.get('urlFormControl').value.trim();
  this.model.sdsurl = this.createManufacturerForm.get('sdsUrlFormControl').value === null ? '' : 
  this.createManufacturerForm.get('sdsUrlFormControl').value.trim();
  this.model.createAlternateName = this.createManufacturerForm.get('alternativeNamesFormControl').value === null ? '' :
   this.createManufacturerForm.get('alternativeNamesFormControl').value.trim();
  this.model.notes = this.createManufacturerForm.get('notesFormControl').value === null ? '' :
   this.createManufacturerForm.get('notesFormControl').value.trim();
  this.model.contactLocationId = this.selectedSearchParameter;
  this.model.mostrecentcontact = this.mostRecentContact;
  this.model.contactEmail = this.createManufacturerForm.get('emailContactFormControl').value === null ? '' :
   this.createManufacturerForm.get('emailContactFormControl').value.trim();
  this.model.contactUrl = this.createManufacturerForm.get('formUrlContactFormControl').value === null ? '' :
   this.createManufacturerForm.get('formUrlContactFormControl').value.trim();
  this.model.contactPhoneNumber = this.createManufacturerForm.get('phoneContactFormControl').value === null ? '' :
   this.createManufacturerForm.get('phoneContactFormControl').value.trim();
  this.model.contactFaxNumber = this.createManufacturerForm.get('faxContactFormControl').value === null ? '' :
   this.createManufacturerForm.get('faxContactFormControl').value.trim();
  this.model.contactDetails = this.createManufacturerForm.get('contactDetailsFormControl').value === null ? '' :
   this.createManufacturerForm.get('contactDetailsFormControl').value.trim();
   this.validateEffectiveContactMethods();
   this.model.effectiveContactMethod = this.effectiveContactMethodArray.length == 0 ? null : this.effectiveContactMethodArray;

    return this.manufacturerService.createManufacturer(this.model).subscribe(
    res => {
      console.log(res);
      this.setManufacturer.emit(res);
      
      const duplicateManufacturerName = res.headers.get('duplicateManufacturer');
      const manufacturerCreatedSuccess = res.headers.get('manufacturerCreated');
      
      if (duplicateManufacturerName) {
        this.alertify.error(duplicateManufacturerName);
        this.isLoading = false;
      } else if (manufacturerCreatedSuccess) {
        this.alertify.success(manufacturerCreatedSuccess);
        this.isLoading = false;
      } else {
        this.alertify.success('New Manufacturer has been created successfully');
        this.isLoading = false;
      }
    }, error => {
      this.alertify.error('Failed to create manufacturer. Please try again.');
      this.isLoading = false;
      console.error('Error creating manufacturer:', error);
    });
}
}

export interface ContactLocationCategory {
  value: string;
  viewValue: string;
}

export interface ContactLocationGroup {
  disabled?: boolean;
  name: string;
  contactLocation: ContactLocationCategory[];
}
